// extracted by css-extract-rspack-plugin
export default {"pageTopToolsContainer":"Presenter__pageTopToolsContainer--Jc0dI","buttonWrap":"Presenter__buttonWrap--x8XpA","pagerContainer":"Presenter__pagerContainer--M25Ki"};